import { ReactNode } from 'react';
import SidebarDesktop from './sidebar-desktop.component';
import SidebarMobile from './sidebar-mobile.component';

const Sidebar = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <SidebarMobile>{children}</SidebarMobile>
      <SidebarDesktop>{children}</SidebarDesktop>
    </>
  );
};

export default Sidebar;
